import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { COURIER_TEMPLATES_BASE_URL } from './helpers';
import { ICourierNotificationTemplateListResponse } from './types';

export const useCourierTemplates = () => {
  const { data, error, isLoading, mutate } =
    useSWR<ICourierNotificationTemplateListResponse>(
      COURIER_TEMPLATES_BASE_URL,
      SWRFetcher({ method: 'GET' })
    );

  return { data, error, isLoading, mutate };
};
